import React, { useEffect, useState } from "react";
import backend from "../../backend";
import useTitle from "../../hooks/useTitle";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const STATUS_STYLE = {
  active:   { label: "Activa",    bg: "#0d2a15", color: "#2ecc71", border: "#0d4020" },
  inactive: { label: "Inactiva",  bg: "#2d1515", color: "#e74c3c", border: "#4a2020" },
  archived: { label: "Archivada", bg: "#222",    color: "#aaa",    border: "#3a3a3a" },
};

const S = {
  wrap: {
    display: "block", padding: "18px 22px", background: "#1a1a1a",
    minHeight: "100%", color: "#ddd", fontFamily: "Arial,sans-serif",
    fontSize: 13, textAlign: "left", boxSizing: "border-box", width: "100%",
  },
  input: {
    background: "#161616", border: "1px solid #333", borderRadius: 5,
    padding: "7px 10px", fontSize: 12, color: "#ddd",
    fontFamily: "Arial,sans-serif", boxSizing: "border-box",
  },
  sectionTitle: {
    fontSize: 10, fontWeight: 700, color: "#999",
    textTransform: "uppercase", letterSpacing: ".07em",
    margin: "20px 0 10px",
  },
  th: {
    background: "#1a1a1a", padding: "7px 10px", textAlign: "left",
    fontSize: 10, fontWeight: 700, color: "#999",
    borderBottom: "1px solid #2e2e2e", textTransform: "uppercase",
    letterSpacing: ".04em", whiteSpace: "nowrap",
  },
  td: {
    padding: "7px 10px", color: "#bbb",
    borderBottom: "1px solid #252525",
    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
  },
};

const Machines = () => {
  useTitle("Máquinas");
  const navigate = useNavigate();
  const location = useLocation();

  const [machines,     setMachines]     = useState([]);
  const [machineTypes, setMachineTypes] = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [filter,       setFilter]       = useState("");
  const [tab,          setTab]          = useState("");

  const handleDeleteMachine = async (id) => {
    try {
      await backend.delete("machine", { data: { _id: id } });
      setMachines(prev => prev.filter(m => m._id !== id));
    } catch(e) { console.error(e); alert("Error al eliminar"); }
  };

  const handleDeleteType = async (id) => {
    try {
      await backend.patch("machineType/archive", { _id: id });
      setMachineTypes(prev => prev.filter(t => t._id !== id));
    } catch(e) { console.error(e); alert("Error al archivar tipo"); }
  };

  const load = async () => {
    setLoading(true);
    try {
      const [mRes, tRes] = await Promise.all([
        backend.get("machine"),
        backend.get("machineType"),
      ]);
      setMachines(mRes.data || []);
      setMachineTypes(tRes.data || []);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  useEffect(() => {
    if (location.state?.type) {
      if (location.state?.new)  { setMachineTypes(p => [...p, location.state.new]); }
      if (location.state?.edit) { setMachineTypes(p => p.map(v => v._id === location.state.edit._id ? location.state.edit : v)); }
    } else {
      if (location.state?.new)  { setMachines(p => [...p, location.state.new]); }
      if (location.state?.edit) { setMachines(p => p.map(v => v._id === location.state.edit._id ? location.state.edit : v)); }
    }
    if (location.state) navigate("", { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const filtered = machines.filter(m => {
    const q = filter.toLowerCase();
    const matchText = !q || (m.name||"").toLowerCase().includes(q) || (m.type?.type||"").toLowerCase().includes(q);
    const matchTab  = !tab || m.status === tab;
    return matchText && matchTab && m.status !== "archived";
  });

  const activas   = machines.filter(m => m.status === "active").length;
  const inactivas = machines.filter(m => m.status === "inactive").length;

  return (
    <div style={S.wrap}>

      {/* ── Header ── flexWrap: en teléfono buscador y botones bajan de línea */}
      <div className="maq-header" style={{ display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"space-between", marginBottom:18, flexWrap:"wrap" }}>
        <div className="mv-screen-title" style={{ fontSize:16, fontWeight:700, color:"#fff" }}>Máquinas</div>
        <div style={{ display:"flex", flexDirection:"row", gap:8, alignItems:"center", flexWrap:"wrap" }}>
          <input
            className="maq-search"
            value={filter}
            onChange={e => setFilter(e.target.value)}
            placeholder="Buscar máquina..."
            style={{ ...S.input, width:200 }}
          />
          <button
            onClick={() => navigate("new_type", { state:{ back:true } })}
            style={{
              background:"transparent", color: "#cbd5e1", border:"1px solid #444",
              borderRadius:6, padding:"7px 14px", fontSize:12, cursor:"pointer",
            }}
          >+ Tipo</button>
          <button
            onClick={() => navigate("new", { state:{ back:true } })}
            style={{
              background:"#e30613", color:"#fff", border:"none",
              borderRadius:6, padding:"7px 16px", fontSize:12,
              fontWeight:700, cursor:"pointer",
            }}
          >+ Nueva máquina</button>
        </div>
      </div>

      {/* ── Métricas ── (maq-metrics/maq-metric: 2x2 en teléfono) */}
      <div className="maq-metrics" style={{ display:"flex", flexDirection:"row", gap:8, marginBottom:18 }}>
        {[
          { label:"Total",    value:machines.filter(m=>m.status!=="archived").length, color:"#ddd"    },
          { label:"Activas",  value:activas,                                           color:"#2ecc71" },
          { label:"Inactivas",value:inactivas,                                         color:"#e74c3c" },
          { label:"Tipos",    value:machineTypes.filter(t=>t.status!=="archived").length, color:"#3498db" },
        ].map(m => (
          <div key={m.label} className="maq-metric" style={{
            flex:"1 1 0", background:"#242424", border:"1px solid #2e2e2e",
            borderRadius:8, padding:"10px 14px",
          }}>
            <div style={{ fontSize:10, color: "#aaa", marginBottom:3, textTransform:"uppercase", letterSpacing:".05em" }}>{m.label}</div>
            <div style={{ fontSize:22, fontWeight:700, color:m.color }}>{m.value}</div>
          </div>
        ))}
      </div>

      {/* ── Tabs ── */}
      <div style={{ display:"flex", flexDirection:"row", borderBottom:"1px solid #2e2e2e", marginBottom:14 }}>
        {[["","Todas"],["active","Activas"],["inactive","Inactivas"]].map(([key,label]) => (
          <button key={key} onClick={() => setTab(key)} style={{
            padding:"7px 16px", background:"transparent", border:"none",
            borderBottom: tab===key ? "2px solid #e30613" : "2px solid transparent",
            color: tab===key ? "#fff" : "#555",
            fontSize:12, fontWeight: tab===key ? 700 : 400, cursor:"pointer",
          }}>{label}</button>
        ))}
      </div>

      {/* ── Tabla máquinas ── */}
      <div style={{ border:"1px solid #2e2e2e", borderRadius:8, overflow:"hidden", background:"#242424", marginBottom:24 }}>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12, tableLayout:"fixed" }}>
          <thead>
            <tr>
              <th style={{ ...S.th }}>Nombre</th>
              <th style={{ ...S.th, width:160 }}>Tipo</th>
              <th style={{ ...S.th, width:90  }}>Estado</th>
              <th style={{ ...S.th, width:110 }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} style={{ ...S.td, textAlign:"center", color: "#999", padding:"24px 0" }}>Cargando…</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={4} style={{ ...S.td, textAlign:"center", color: "#999", padding:"24px 0" }}>
                {filter ? "Sin resultados" : "No hay máquinas registradas"}
              </td></tr>
            ) : (
              filtered.map((m, i) => {
                const ss = STATUS_STYLE[m.status] || STATUS_STYLE.inactive;
                return (
                  <tr key={m._id || i}
                    onMouseEnter={e => Array.from(e.currentTarget.cells).forEach(c => c.style.background="#2a2a2a")}
                    onMouseLeave={e => Array.from(e.currentTarget.cells).forEach(c => c.style.background="")}
                  >
                    <td style={{ ...S.td, color:"#fff", fontWeight:600 }}>{m.name}</td>
                    <td style={S.td}>{m.type?.type || "—"}</td>
                    <td style={{ ...S.td, overflow:"visible" }}>
                      <span style={{
                        display:"inline-block", fontSize:10, fontWeight:700,
                        padding:"2px 7px", borderRadius:20,
                        background:ss.bg, color:ss.color, border:`1px solid ${ss.border}`,
                      }}>{ss.label}</span>
                    </td>
                    <td style={{ ...S.td, overflow:"visible" }}>
                      <div style={{ display:"flex", flexDirection:"row", gap:4 }}>
                        <button
                          className="no-touch-min maq-icon-btn"
                          onClick={() => navigate("edit", { state:{ _id:m._id, back:true } })}
                          style={{ width:26, height:26, border:"none", background:"#2d2000", color:"#f39c12", borderRadius:5, cursor:"pointer", fontSize:12 }}
                          title="Editar"
                        ><i className="bi bi-pencil" /></button>
                        <button
                          className="no-touch-min maq-icon-btn"
                          onClick={() => { if(window.confirm(`¿Eliminar "${m.name}"?`)) handleDeleteMachine(m._id); }}
                          style={{ width:26, height:26, border:"none", background:"#2d1515", color:"#e74c3c", borderRadius:5, cursor:"pointer", fontSize:12 }}
                          title="Eliminar"
                        ><i className="bi bi-trash" /></button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* ── Tipos de máquinas ── */}
      <div style={S.sectionTitle}>Tipos de máquinas</div>
      <div style={{ border:"1px solid #2e2e2e", borderRadius:8, overflow:"hidden", background:"#242424" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
          <thead>
            <tr>
              <th style={{ ...S.th }}>Tipo</th>
              <th style={{ ...S.th, width:110 }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {machineTypes.filter(t => t.status !== "archived").length === 0 ? (
              <tr><td colSpan={2} style={{ ...S.td, textAlign:"center", color: "#999", padding:"24px 0" }}>Sin tipos registrados</td></tr>
            ) : (
              machineTypes.filter(t => t.status !== "archived").map((t, i) => (
                <tr key={t._id || i}
                  onMouseEnter={e => Array.from(e.currentTarget.cells).forEach(c => c.style.background="#2a2a2a")}
                  onMouseLeave={e => Array.from(e.currentTarget.cells).forEach(c => c.style.background="")}
                >
                  <td style={{ ...S.td, color:"#fff" }}>{t.type}</td>
                  <td style={{ ...S.td, overflow:"visible" }}>
                    <div style={{ display:"flex", flexDirection:"row", gap:4 }}>
                      <button
                        className="no-touch-min maq-icon-btn"
                        onClick={() => navigate("edit_type", { state:{ _id:t._id, back:true } })}
                        style={{ width:26, height:26, border:"none", background:"#2d2000", color:"#f39c12", borderRadius:5, cursor:"pointer", fontSize:12 }}
                        title="Editar"
                      ><i className="bi bi-pencil" /></button>
                      <button
                        className="no-touch-min maq-icon-btn"
                        onClick={() => { if(window.confirm(`¿Archivar el tipo "${t.type}"?`)) handleDeleteType(t._id); }}
                        style={{ width:26, height:26, border:"none", background:"#2d1515", color:"#e74c3c", borderRadius:5, cursor:"pointer", fontSize:12 }}
                        title="Archivar"
                      ><i className="bi bi-archive" /></button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Outlet />
    </div>
  );
};

export default Machines;
